import React from "react";
// import DashboardContent from '../function-components/DashboardContent';
import DashboardContent from "../function-components/DashboardContent";

function Dashboard() {
  return (
    <>
      <DashboardContent />
    </>
  );
}

export default Dashboard;
